module.exports = __webpack_public_path__ + "media/images/konintodoke/banner/banner-be7e449b60ec2a5ebc268e99921d955c.jpg";